import { Col, Row, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import ActionBar from '../../../../../components/action-bar';
import ActionButton from '../../../../../components/action-button';
import TextItem from '../../../../../components/text-item';
import useFormatter from '../../../../../hooks/useFormatter';
import useLoading from '../../../../../hooks/useLoading';
import { fetchSocio, isEditableSelector, socioSelector } from '../../../../../store/empresa';
import { formatDocumento } from '../../../../../util/documento';
import { openPopup } from '../../../../../util/window';
import useModulo from '../../../../../hooks/useModulo';
import { Alerta } from '../../../../../constants';
import { sociosAlertaNivelSelector } from '../../../../../store/empresa';
import { useLocation } from "react-router";
import { useState } from "react";
import TarefasDrawer from '../../../licencas/_tarefasDrawer';

export default function EmpresaSocioDetailPage1() {
  const { t } = useTranslation();
  const isEditable = useSelector(isEditableSelector);
  const socio = useSelector(socioSelector);
  const { formatBoolean, formatDateTime, formatCurrency, formatNumber } = useFormatter();
  const loading = useLoading(fetchSocio.typePrefix);
  const history = useHistory();
  const match = useRouteMatch();
  const nivel = useSelector(sociosAlertaNivelSelector);
  const empresaId = match.params.empresaId;
  const id = match.params.id;
  const { moduloBasePath } = useModulo();
   const location = useLocation();
    const pathname = location.pathname;
    const origem = pathname.substring(pathname.indexOf("/empresas"));
    const modulo = pathname.split("/")[1];
    const [tarefasDrawerVisible, setTarefasDrawerVisible] = useState(false);

  const isNA = nivel === Alerta.Nivel.NA.id || nivel === Alerta.Nivel.inativo.id;

  const handleEdit = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/socios/${id}/edit`);
  };

  const handleBack = () => {
    history.replace(`${moduloBasePath}/empresas/${empresaId}/socios`);
  };

  const handleLogs = () => {
    openPopup(`/logs?categoria=/empresas/${empresaId}/socios/${id}/`, `logs_/empresas/${empresaId}/socios/${id}/`);
  };

  return (
    <Spin spinning={loading}>
       <TarefasDrawer visible={tarefasDrawerVisible} origem={origem} modulo={modulo} empresaId={empresaId}  onClose={() => setTarefasDrawerVisible(false)} />
      <ActionBar>
        <ActionButton.Tarefa disabled={isNA} onClick={() => setTarefasDrawerVisible(true)} />
        {isEditable && <ActionButton.Edit onClick={handleEdit} disabled={isNA} />}
        <ActionButton.Back onClick={handleBack} />
        <ActionButton.Logs noTitle onClick={handleLogs} />
      </ActionBar>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t('CPF/CNPJ')}>{formatDocumento(socio?.documento)}</TextItem>
        </Col>
        <Col flex="400px">
          <TextItem label={t('Nome')}>{socio?.nome}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('email')}>{socio?.email}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label={t('Domicílio Estrangeiro')}>{formatBoolean(socio?.exterior)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Quotas')}>{formatNumber(socio?.capitalQuantidade)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Valor Nominal Unitário (R$)')}>{formatCurrency(socio?.capitalValorUnitario)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label={t('Menor Incapacitado')}>{formatBoolean(socio?.incapacitado)}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="800px">
          <TextItem label={t('Observação')}>{socio?.obs}</TextItem>
        </Col>
      </Row>
      <Row gutter={[16, 8]}>
        <Col flex="200px">
          <TextItem label="Criado em">{formatDateTime(socio?.createdAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Alterado em">{formatDateTime(socio?.updatedAt)}</TextItem>
        </Col>
        <Col flex="200px">
          <TextItem label="Id">{socio?.id}</TextItem>
        </Col>
      </Row>
    </Spin>
  );
}
